// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__1vPiT","fw500":"Heading_fw500__WZKtZ","fw600":"Heading_fw600__XE-VC","fw700":"Heading_fw700__+bZ26"};